/* global axios */

const get = accountId =>
  axios.get(`/api/v1/accounts/${accountId}/pipeline_roles`);

const show = (accountId, id) =>
  axios.get(`/api/v1/accounts/${accountId}/pipeline_roles/${id}`);

const create = (accountId, payload) =>
  axios.post(`/api/v1/accounts/${accountId}/pipeline_roles`, {
    pipeline_role: payload,
  });

const update = (accountId, id, payload) =>
  axios.patch(`/api/v1/accounts/${accountId}/pipeline_roles/${id}`, {
    pipeline_role: payload,
  });

const destroy = (accountId, id) =>
  axios.delete(`/api/v1/accounts/${accountId}/pipeline_roles/${id}`);

const getPermissionKeys = accountId =>
  axios.get(`/api/v1/accounts/${accountId}/pipeline_roles/permission_keys`);

const assignAgent = (accountId, { accountUserId, pipelineRoleId }) =>
  axios.patch(`/api/v1/accounts/${accountId}/pipeline_roles/assign_agent`, {
    account_user_id: accountUserId,
    pipeline_role_id: pipelineRoleId,
  });

export default {
  get,
  show,
  create,
  update,
  delete: destroy,
  getPermissionKeys,
  assignAgent,
};
